module.exports = __webpack_public_path__ + "img/kicks_side.d8b4ff48.png";